export function ContentCardHeader({ children, title }) {
  return (
    <div className="d-flex flex-column w-100 pr-3">
      <p
        className="text-uppercase font-weight-bold mb-1 text-truncate-2"
        title={title}
      >
        {title}
      </p>
      <div
        className="d-flex align-items-center text-muted"
        style={{ fontSize: "0.75rem" }}
      >
        {children}
      </div>
    </div>
  );
}
